export default __webpack_public_path__ + "static/media/i61.f420ecc6.svg";